import { render, staticRenderFns } from "./SensorVirtualInput.vue?vue&type=template&id=28ce0d90&scoped=true&"
import script from "./SensorVirtualInput.vue?vue&type=script&lang=js&"
export * from "./SensorVirtualInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ce0d90",
  null
  
)

export default component.exports